import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const createAccountPageLink = getPageLinkByPageType(state, "CreateAccountPage");
    return {
        createAccountUrl: createAccountPageLink ? `${createAccountPageLink.url}` : undefined,
    }
}


interface OwnProps {
    isOpen?: boolean;
    setTrainingRedirectHandler?: React.Dispatch<React.SetStateAction<boolean>>;
    redirectHandler?: (from: string) => void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;
export interface RedirectionPopupStyle {
    modal?: ModalPresentationProps;
    formContent?: InjectableCss;
    buttonWrapper?: InjectableCss;
    separatorWrapper?: InjectableCss;
    buttons?: ButtonPresentationProps;
}

export const redirectionPopupStyle: RedirectionPopupStyle = {
    modal: {
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
                [class^="ButtonWrapper"] {
                    border: solid 2px;
                    border-radius: 50%;
                }
                svg {
                    height: 20px;
                    width: 20px;
                }
                [class^="IconWrapper"] {
                    top: 0em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            `,
            modalContent: css`
                padding: 0px;
            `,
            modalContainer: css`
                height: 100vh;
                align-items: center;
                [class^="ContentBody"] {
                    max-height: 100vh;
                    max-width: 100%;
                    width: 500px;
                }
                [class^="FormInputWrapper"] {
                    [class^="DescriptionWrapper"] {
                        margin-top: 0;
                    }
                }
            `,
        },
    },
    formContent: {
        css: css`
            padding: 20px;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
        `,
    },
    buttons: {
        css: css`
            width: 100%;
        `,
    },
    separatorWrapper: {
        css: css`
            padding: 15px 0px;
            text-align: center;
        `,
    }
};

const styles = redirectionPopupStyle;

const TrainingRedirectionPopup = ({
    redirectHandler
}: Props) => {
    const history = useHistory();

    return (
            <>
                <StyledWrapper {...styles.formContent}>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button
                            {...styles.buttons}
                            variant="secondary"
                            onClick={() => {
                                redirectHandler && redirectHandler("createAccount");
                            }}
                        >
                            {translate("Create New Account")}
                        </Button>
                    </StyledWrapper>
                    <StyledWrapper {...styles.separatorWrapper}>
                        Or
                    </StyledWrapper>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button
                            {...styles.buttons}
                            type="submit"
                            variant="primary"
                            onClick={() => {
                                redirectHandler && redirectHandler("signIn");
                            }}
                        >
                            {translate("Sign In")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </>
    );
};

export default connect(mapStateToProps)(TrainingRedirectionPopup);
